import { render } from "./FilterandSearch.vue?vue&type=template&id=51483ccf"
import script from "./FilterandSearch.vue?vue&type=script&lang=js"
export * from "./FilterandSearch.vue?vue&type=script&lang=js"

import "./FilterandSearch.vue?vue&type=style&index=0&id=51483ccf&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__